module.exports = __webpack_public_path__ + "media/images/cherry-84df4e115f237bad3a42baa5937c3a22.svg";